import React from 'react'

import {
  AlignItems,
  Box,
  Display,
  FlexDirection,
  FontWeight,
  Text,
} from '@gousto-internal/citrus-react'

type CollectionDescriptionProps = {
  title: string
  subtitle: string
}

export const CollectionDescription = ({ title, subtitle }: CollectionDescriptionProps) => (
  <Box
    display={Display.Flex}
    flexDirection={[FlexDirection.Column, FlexDirection.Row]}
    alignItems={[AlignItems.FlexStart, AlignItems.Center]}
    gap={[0, 2]}
    paddingBottom={4}
  >
    <Text fontWeight={FontWeight.Bold}>{title}</Text>
    <Text size={[1, 4, 6]}>{subtitle}</Text>
  </Box>
)
